var map = {
	"./海吉星报告01.png": 5446,
	"./海吉星报告02.png": 4882,
	"./海吉星报告03.png": 6427,
	"./海吉星报告04.png": 1620,
	"./海吉星报告05.png": 4861,
	"./海吉星报告06.png": 3094
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7705;